import {
  Accordion,
  Badge,
  Box,
  Button,
  Flex,
  Group,
  MultiSelect,
  Paper,
  Select,
  Stack,
  Text,
} from "@mantine/core";
import { useMediaQuery } from "@mantine/hooks";
import {
  IconCalendar,
  IconChevronDown,
  IconFilter,
  IconMapPin,
  IconX,
} from "@tabler/icons-react";
import Search from "../Sessions/Search";
import { useTranslation } from "react-i18next";

const Filters = ({
  hasActiveFilters,
  selectedDate,
  selectedLocations,
  dateOptions,
  setSelectedDate,
  locationOptions,
  setSelectedLocations,
  clearFilters,
  searchValue,
  handleSearchChange,
}) => {
  const isMobile = useMediaQuery("(max-width: 768px)");
  const { t } = useTranslation();

  return (
    <Paper shadow="sm" radius="md" mb="xl" withBorder>
      {isMobile ? (
        <Accordion variant="contained" chevron={<IconChevronDown size={16} />}>
          <Accordion.Item value="filters">
            <Accordion.Control icon={<IconFilter size={20} />}>
              <Group gap="xs">
                <Text fw={500}>{t("filters")}</Text>
                {hasActiveFilters && (
                  <Badge size="sm" variant="filled" color="congrsMain">
                    {(selectedDate ? 1 : 0) + selectedLocations.length}
                  </Badge>
                )}
              </Group>
            </Accordion.Control>
            <Accordion.Panel>
              <Stack gap="md">
                <Select
                  label={t("filter_by_date")}
                  placeholder={t("all_dates")}
                  data={dateOptions}
                  value={selectedDate}
                  onChange={setSelectedDate}
                  clearable
                  leftSection={<IconCalendar size={16} />}
                />
                <MultiSelect
                  label={t("filter_by_location")}
                  placeholder={t("all_locations")}
                  data={locationOptions}
                  value={selectedLocations}
                  onChange={setSelectedLocations}
                  clearable
                  leftSection={<IconMapPin size={16} />}
                />
                <Search
                  marginBottom={0}
                  width={""}
                  label={t("search_sessions")}
                  placeholder={t("search_sessions_placeholder")}
                  value={searchValue}
                  onChange={handleSearchChange}
                />
                {hasActiveFilters && (
                  <Button
                    variant="light"
                    color="gray"
                    onClick={clearFilters}
                    leftSection={<IconX size={16} />}
                    fullWidth
                  >
                    {t("clear_filters")}
                  </Button>
                )}
              </Stack>
            </Accordion.Panel>
          </Accordion.Item>
        </Accordion>
      ) : (
        <Box p="md">
          <Flex gap="md" align="flex-end">
            <Box style={{ flex: 1 }}>
              <Select
                label={t("filter_by_date")}
                placeholder={t("all_dates")}
                data={dateOptions}
                value={selectedDate}
                onChange={setSelectedDate}
                clearable
                searchable
                nothingFoundMessage={t("nothing_found")}
                leftSection={<IconCalendar size={16} />}
              />
            </Box>
            <Box style={{ flex: 1 }}>
              <MultiSelect
                label={t("filter_by_location")}
                placeholder={t("all_locations")}
                data={locationOptions}
                value={selectedLocations}
                onChange={setSelectedLocations}
                clearable
                searchable
                nothingFoundMessage={t("nothing_found")}
                leftSection={<IconMapPin size={16} />}
              />
            </Box>
            <Box style={{ flex: 1 }}>
              <Search
                marginBottom={0}
                width={""}
                label={t("search_sessions")}
                placeholder={t("search_sessions_placeholder")}
                value={searchValue}
                onChange={handleSearchChange}
              />
            </Box>
            {hasActiveFilters && (
              <Button
                variant="light"
                color="gray"
                onClick={clearFilters}
                leftSection={<IconX size={16} />}
              >
                {t("clear_filters")}
              </Button>
            )}
          </Flex>
        </Box>
      )}
    </Paper>
  );
};

export default Filters;
